import { render } from "./popup-slider.vue?vue&type=template&id=10349cf5"
import script from "./popup-slider.vue?vue&type=script&lang=js"
export * from "./popup-slider.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__